import styled, { css } from "styled-components";
import { parseCSS } from "scripts/FunctionsBundle";
import NewText from "@components/NewText";

// ################################ INTERFACES & PROPS ################################

type _Base = import("utils/class-types").Base;
// ContactScreen => Rename all instances to use
type ContactScreenProps = {} & _Base;

// ################################ RENDERING COMPONENT ################################

const _ContactScreen = (props: ContactScreenProps) => {
  return (
    <div className={props.className + " screen"}>
      <NewText _text={"This is the Suggestions Screen"} _type={"subtitle"} />
    </div>
  );
};

// ################################ STYLES ################################
const ContactScreen = styled(_ContactScreen).attrs(
  (props): ContactScreenProps => {
    return { ...props };
  }
)`
  ${(props) => css`
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################

export default ContactScreen;
